module.exports = __webpack_public_path__ + "img/5.20eb026a.jpg";